import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent implements OnInit {
  days: number;
  hours: string;
  minutes: string;
  seconds: string;

  constructor() { }

  ngOnInit(): void {
    this.countdown();
  }

  countdown() {
    const countdownFunction = setInterval(() => {
      const now = new Date();
      const eventDate = new Date('2023-09-01');
      
      const remTime = eventDate.getTime() - now.getTime();

      let s = Math.floor(remTime / 1000);
      let m = Math.floor(s / 60);
      let h = Math.floor(m / 60);
      let d = Math.floor(h / 24);
  
      h %= 24;
      m %= 60;
      s %= 60;

      this.days = d;
      this.hours = (h < 10) ? "0" + h : h.toString();
      this.minutes = (m < 10) ? "0" + m : m.toString();
      this.seconds = (s < 10) ? "0" + s : s.toString();

      if (remTime <= 0) {
        clearInterval(countdownFunction);
        this.days = 0;
        this.hours = '00';
        this.minutes = '00';
        this.seconds = '00';
      }
    }, 1000);
  }
}
